import {HttpService} from "../http/HttpService";
import {AdminUser, ChangePasswordLoginRequest, LoginRequest, LoginResponse} from "../http/protocol";


export class UserAuthenticationService   {

    constructor(private http: HttpService) {}

    loadUserInfo() : Promise<AdminUser> {
        return this.http.get<AdminUser>("/user/info");
    }
    logout() : Promise<{}> {
        return this.http.get<{}>("/user/logout");
    }

    refreshToken() : Promise<LoginResponse> {
        return this.http.get<LoginResponse>("/user/refresh-token");
    }

    login(username : string, password : string) {
        return this.http.post<LoginResponse,LoginRequest>("/user/login",
            { username : username, password: password}) ;
    }
    getGroupPermissions() : Promise<{[key:string]:boolean} >{
        return this.http.get<{[key:string]:boolean}>("/user/group-permissions");
    }

    changePasswordAndLogin(username: string, password: string, newPassword: string): Promise<LoginResponse> {
        return this.http.post<LoginResponse,ChangePasswordLoginRequest>("/user/change-password-and-login", {
            oldPassword : password,
            loginRequest : { username : username, password : newPassword }
        });
    }

}